module.exports = __webpack_public_path__ + "img/cb1.50e5f4bf.jpg";